import { render, staticRenderFns } from "./HotIssue.vue?vue&type=template&id=7d085824&"
import script from "./HotIssue.vue?vue&type=script&lang=js&"
export * from "./HotIssue.vue?vue&type=script&lang=js&"
import style0 from "./HotIssue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports